import * as types from '../../index';

export const listVehicleFieldsMasterAction = (data) => {
    return {
    type: types.LIST_VEHICLE_FIELDS_MASTER,
    data
    }
};

export const addVehicleFieldaMasterAction = (data) => {
    return {
    type: types.ADD_VEHICLE_FIELDS_MASTER,  
    data
    }
}

export const updateVehicleFieldaMasterAction = (data) => {
    return {
    type: types.UPDATE_VEHICLE_FIELDS_MASTER,  
    data
    }
}

export const deleteVehicleFieldaMasterAction = (data) => {
    return {
    type: types.DELETE_VEHICLE_FIELDS_MASTER,  
    data
    }
}

